__turbopack_context__.v({
  "avatarBronze": "TopFansCard-module-scss-module__uYQ12W__avatarBronze",
  "avatarFrame": "TopFansCard-module-scss-module__uYQ12W__avatarFrame",
  "avatarGold": "TopFansCard-module-scss-module__uYQ12W__avatarGold",
  "avatarImg": "TopFansCard-module-scss-module__uYQ12W__avatarImg",
  "avatarMuted": "TopFansCard-module-scss-module__uYQ12W__avatarMuted",
  "avatarPlaceholder": "TopFansCard-module-scss-module__uYQ12W__avatarPlaceholder",
  "avatarSilver": "TopFansCard-module-scss-module__uYQ12W__avatarSilver",
  "card": "TopFansCard-module-scss-module__uYQ12W__card",
  "content": "TopFansCard-module-scss-module__uYQ12W__content",
  "header": "TopFansCard-module-scss-module__uYQ12W__header",
  "link": "TopFansCard-module-scss-module__uYQ12W__link",
  "linkIcon": "TopFansCard-module-scss-module__uYQ12W__linkIcon",
  "linkText": "TopFansCard-module-scss-module__uYQ12W__linkText",
  "name": "TopFansCard-module-scss-module__uYQ12W__name",
  "pedestal": "TopFansCard-module-scss-module__uYQ12W__pedestal",
  "pedestalItem": "TopFansCard-module-scss-module__uYQ12W__pedestalItem",
  "pedestalItemBronze": "TopFansCard-module-scss-module__uYQ12W__pedestalItemBronze",
  "pedestalItemGold": "TopFansCard-module-scss-module__uYQ12W__pedestalItemGold",
  "pedestalItemSilver": "TopFansCard-module-scss-module__uYQ12W__pedestalItemSilver",
  "pedestalItemThin": "TopFansCard-module-scss-module__uYQ12W__pedestalItemThin",
  "pedestalTextBronze": "TopFansCard-module-scss-module__uYQ12W__pedestalTextBronze",
  "pedestalTextGold": "TopFansCard-module-scss-module__uYQ12W__pedestalTextGold",
  "pedestalTextMuted": "TopFansCard-module-scss-module__uYQ12W__pedestalTextMuted",
  "pedestalTextSilver": "TopFansCard-module-scss-module__uYQ12W__pedestalTextSilver",
  "slot": "TopFansCard-module-scss-module__uYQ12W__slot",
  "textBronze": "TopFansCard-module-scss-module__uYQ12W__textBronze",
  "textGold": "TopFansCard-module-scss-module__uYQ12W__textGold",
  "textMuted": "TopFansCard-module-scss-module__uYQ12W__textMuted",
  "textSilver": "TopFansCard-module-scss-module__uYQ12W__textSilver",
  "title": "TopFansCard-module-scss-module__uYQ12W__title",
  "value": "TopFansCard-module-scss-module__uYQ12W__value",
});
